export default {
  header: "Ready to eat pizza",
  view: "Bio"
};
